import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getItemByCommonPropertyValue } from '@mews/fp';
import { canCurrentProfileOverrideRatePrice } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getCheckedReservations } from '../../selectors';

export const getRateFormInitialValues = createSelector(
    createSelector(getCheckedReservations, getItemByCommonPropertyValue('rateId')),
    canCurrentProfileOverrideRatePrice,
    (rateId, hasPrivilege) => ({
        rateId,
        keepOldPrice: hasPrivilege ? true : undefined,
    })
);
export const getRateFormServiceId = flow(getCheckedReservations, getItemByCommonPropertyValue('serviceId'));
